export enum StarterKitStatus {
    RETURNEDPURCHASED = "Returned/Purchased", 
    NOTRETURNED = "Not Returned"
}